import { _Button } from "./_Button";
import { CascadiaButtonProps } from "./types";

interface Props extends CascadiaButtonProps {
  className?: string; // className isn't supported in React Native
}

export function BasicButton(props: Props) {
  return (
    <_Button
      border="border-button"
      color="text-base"
      fill="background-base"
      focusStyle="focus-action"
      hoverFill="background-accent-neutral-weak"
      iconColor="icon-base"
      shadow="shadow-button"
      loaderColor="icon-success"
      {...props}
    />
  );
}
